import { getValueInUsd } from "@src/appV2/lib/Money/utils/currency";

interface CalculateTen99PolicyFeeParams {
  instantPayTotalAmount: number;
  ten99PolicyAssignmentNetRateInCents: number;
}

export function calculateTen99PolicyFeeInDollars(params: CalculateTen99PolicyFeeParams): number {
  const { instantPayTotalAmount, ten99PolicyAssignmentNetRateInCents } = params;

  const totalPerOneHundredDollars = instantPayTotalAmount / 100;

  const ten99PolicyFeeInCents = totalPerOneHundredDollars * ten99PolicyAssignmentNetRateInCents;
  return getValueInUsd(ten99PolicyFeeInCents);
}
